"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderRatingSummary = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const StarOutline_1 = __importDefault(require("@kyruus/react-ikons/StarOutline"));
const Star_1 = __importDefault(require("@kyruus/react-ikons/Star"));
const constants_1 = require("../common/util/constants");
const utils_1 = require("../RatingsAndReviewsSummary/utils");
const ProviderRatingSummary_styles_1 = require("./ProviderRatingSummary.styles");
const COMPACT_STAR_SIZE = 18;
const RatingSummaryComponent = (_a) => {
    var { providerReviews, intl } = _a, restProps = __rest(_a, ["providerReviews", "intl"]);
    const aggregateRatings = providerReviews === null || providerReviews === void 0 ? void 0 : providerReviews.aggregate_ratings;
    if (!(aggregateRatings === null || aggregateRatings === void 0 ? void 0 : aggregateRatings.average_rating)) {
        return null;
    }
    const ratingScale = constants_1.DEFAULTS.PROVIDER_RATING_SCALE; // Should be 5
    const filledPercent = `${aggregateRatings.average_rating / (0.01 * ratingScale)}%`;
    return (react_1.default.createElement(ProviderRatingSummary_styles_1.RatingSummaryContainer, Object.assign({ "data-testid": "rating-summary" }, restProps),
        react_1.default.createElement(ProviderRatingSummary_styles_1.StarsContainer, { "aria-hidden": true, ratingScale: ratingScale, size: COMPACT_STAR_SIZE },
            react_1.default.createElement(ProviderRatingSummary_styles_1.StarsWrapper, null,
                react_1.default.createElement(ProviderRatingSummary_styles_1.EmptyStars, null, (0, utils_1.iconArrayCreator)(StarOutline_1.default, ratingScale, COMPACT_STAR_SIZE)),
                react_1.default.createElement(ProviderRatingSummary_styles_1.FilledStars, { filledPercent: filledPercent }, (0, utils_1.iconArrayCreator)(Star_1.default, ratingScale, COMPACT_STAR_SIZE)))),
        react_1.default.createElement(ProviderRatingSummary_styles_1.RatingText, null,
            aggregateRatings.average_rating.toFixed(1),
            aggregateRatings.rating_count && aggregateRatings.rating_count > 0 && (react_1.default.createElement("span", null,
                ' ',
                "(",
                intl.formatMessage(constants_1.messages.ratingcount, {
                    ratingCount: aggregateRatings.rating_count
                }),
                ")")))));
};
exports.ProviderRatingSummary = (0, intl_1.injectIntl)(RatingSummaryComponent);
//# sourceMappingURL=ProviderRatingSummary.js.map